export default __webpack_public_path__ + "static/media/inventMgmt5.ee615f0e.png";